import { Injector, Signal } from '@angular/core';
import { toSignal, toObservable } from '@angular/core/rxjs-interop';
import {
  interval,
  filter,
  take,
  switchMap,
  combineLatest,
  map,
  startWith,
  Observable,
} from 'rxjs';
import { ChatContentComponent } from 'src/app/features/chat/components/chat-content/chat-content.component';

export function injectHideFab(
  chatComponent: Signal<ChatContentComponent | undefined>,
  viewInit: Observable<boolean>,
  injector: Injector
) {
  return toSignal(
    interval(1000).pipe(
      filter(() => !!chatComponent()?.chatViewport()),
      take(1),
      switchMap(() => viewInit),
      filter((ready) => ready && !!chatComponent()?.chatViewport()),
      switchMap(() => {
        return combineLatest([
          toObservable(chatComponent()!.chatViewport()!.isLastElementVisible, {
            injector: injector,
          }),
          toObservable(chatComponent()!.chatViewport()!.isLoadingBottom, {
            injector: injector,
          }),
        ]).pipe(
          map(
            ([isLastVisible, isLoadingBottom]) =>
              (chatComponent()?.chatViewport()?.list.length ?? 0) === 0 ||
              (isLastVisible &&
                !isLoadingBottom &&
                chatComponent()!.chatViewport()?.listDirective()?.bottomReached)
          )
        );
      }),
      startWith(true)
    )
  );
}
